import { Avatar } from "@mui/material";
import { Weight } from "lucide-react";
import React from "react";

const AvatarName = ({ name, size = "", bgColor = {}, textColor = "", borderColor = "" }) => {
  const dimension = {
    small: "1.50rem", // 24px
    medium: "1.67rem", // 26.72px
    large: "2.50rem", // 40px
  };

  const fontSizes = {
    small: "0.650rem", // 10.5px
    medium: "0.75rem", // 12px
    large: "1.1rem", // 16px
  };

  const fontWeight = {
    small: 400,
    medium: 500,
    large: 500,
  };

  return (
    <Avatar
      sx={{
        width: dimension[size],
        height: dimension[size],
        fontSize: fontSizes[size],
        fontWeight: fontWeight[size],
        backgroundColor: bgColor,
        color: textColor,
        border: borderColor ? `1px solid ${borderColor}` : "none",
        textTransform: "uppercase",
      }}
    >
      {name}
    </Avatar>
  );
};

export default AvatarName;
